import React from 'react';

import { makeStyles } from 'tss-react/mui';
import { useTranslation } from 'react-i18next';
import { TextField } from 'web-library';
import {
  ErrorObject,
  FormIds,
} from '../../../../modules/accessArrangment/components/candidate/SelectCondition/components/SelectConditionContent';

interface OthersTextAreaProps {
  othersString: string;
  setOthersString: (newString: string) => void;
  maxCharacterCount: number;
  formErrors: ErrorObject[];
  displayError: boolean;
}

const findError = (errorId: string, formErrors: ErrorObject[]) =>
  formErrors.find((formError) => formError.id === errorId);

const OthersTextArea = ({
  othersString,
  setOthersString,
  maxCharacterCount,
  formErrors,
  displayError,
}: OthersTextAreaProps) => {
  const { t } = useTranslation();

  const handleTextChange = (e: any) => {
    const newString = e.target.value;
    setOthersString(newString);
  };

  const othersError = findError(FormIds.OTHERS_TEXT_AREA, formErrors)?.text;
  const overLimitError = findError(FormIds.OTHERS_TEXT_AREA_OVER_LIMIT, formErrors)?.text;
  const hasError = (displayError && othersError) || overLimitError;

  const useStyles = makeStyles()((theme) =>
  ({
    textfield: {
      '& .MuiInputBase-root': {
        backgroundColor: hasError
          ? theme.color.state.stateErrorLight
          : theme.color.background.bgField,
        borderColor: hasError ? theme.color.state.stateError : 'none',
        '&:hover': {
          backgroundColor: hasError
            ? theme.color.state.stateErrorLight
            : theme.color.background.bgField,
          borderColor: hasError ? theme.color.state.stateError : 'none',
        },
      },
      marginTop: theme.spacing(6),
    },
    error: {
      color: theme.color.state.stateError,
    },
  }));

  const { classes } = useStyles();

  const generateHelperText = () => {
    switch (true) {
      case !!overLimitError:
        return overLimitError;
      case othersError !== undefined && othersError !== '' && hasError !== undefined && hasError !== '':
        return othersError;
      default:
        return (
          (maxCharacterCount - othersString.length).toString() +
          t('accessArrangement->>SelectCondition.CharactersRemaining')
        );
    }
  };

  return (
    <TextField
      id="text-field-area"
      className={classes.textfield}
      InputLabelProps={{
        id: FormIds.OTHERS_TEXT_AREA,
      }}
      label={
        <span className={hasError ? classes.error : ''}>
          {t('accessArrangement->>SelectCondition.OthersLabel')}
        </span>
      }
      placeholder={t('accessArrangement->>SelectCondition.OthersPlaceholder')}
      multiline
      helperText={<span className={hasError ? classes.error : ''}>{generateHelperText()}</span>}
      onChange={handleTextChange}
      value={othersString}
      rows={5}
    />
  );
};

export default OthersTextArea;
